// This is the entry point for all the Stimulus Controllers that are shared between the "admin app" and the "public app"

import { application } from "../application"

import PhoneNumberInputController from "./phone_number_input_controller"
application.register("phone-number-input", PhoneNumberInputController)

import StripePaymentMethodController from "./stripe_payment_method_controller"
application.register("stripe-payment-method", StripePaymentMethodController)

import MedianPushNotificationStatusController from "./median_push_notification_status_controller"
application.register("median-push-notification-status", MedianPushNotificationStatusController)
